import { render, staticRenderFns } from "./waterfallSlot.vue?vue&type=template&id=4c5eae9e&"
import script from "./waterfallSlot.vue?vue&type=script&lang=js&"
export * from "./waterfallSlot.vue?vue&type=script&lang=js&"
import style0 from "./waterfallSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports